import Frames from "@frog/source/engine/animating/Frames.js"
console.log(Frames.run({
    "tweentime": 80,
    "images": [
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-0.png"),
        require("./archer-idle-1.png"),
        require("./archer-idle-2.png"),
        require("./archer-idle-3.png"),
        require("./archer-idle-4.png"),
        require("./archer-idle-5.png"),
        require("./archer-idle-6.png"),
        require("./archer-idle-5.png"),
        require("./archer-idle-4.png"),
        require("./archer-idle-3.png"),
        require("./archer-idle-2.png"),
        require("./archer-idle-1.png"),
    ]
}))
export default {
    "static": require("./archer-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-0.png"),
                require("./archer-idle-1.png"),
                require("./archer-idle-2.png"),
                require("./archer-idle-3.png"),
                require("./archer-idle-4.png"),
                require("./archer-idle-5.png"),
                require("./archer-idle-6.png"),
                require("./archer-idle-5.png"),
                require("./archer-idle-4.png"),
                require("./archer-idle-3.png"),
                require("./archer-idle-2.png"),
                require("./archer-idle-1.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 60,
            "images": [
                require("./archer-selected-2.png"),
                require("./archer-selected-3.png"),
                require("./archer-selected-4.png"),
                require("./archer-selected-5.png"),
                require("./archer-selected-6.png"),
                require("./archer-selected-7.png"),
                require("./archer-selected-0.png"),
                require("./archer-selected-0.png"),
                require("./archer-selected-0.png"),
                require("./archer-selected-0.png"),
                require("./archer-selected-1.png"),
            ]
        })
    },
}
